import myExam from "../../layout/myExam"
// 注意路由格式前缀一定要加/myExam
export default {
    path: "/myExam/index",
    component: myExam,
    redirect: "/myExam/testingCenter",
    alwaysShow: true,
    name: "myExam",
    children: [
        {
            path: "/myExam/testingCenter",
            name: "testingCenterIndex",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中心',index:0
            },
            component: () => import("@/weMyExamViews/myExam/index")  
        }, {
            path: "/myExam/mobileMyExam",
            name: "mobileMyExamIndex",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中心',index:0
            },
            component: () => import("@/weMyExamViews/mobileExam/mobileMyExam")  
        },
        {
            path: "/myExam/examLogin",
            name: "examLogin",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考生登录',index:1
            },
            component: () => import("@/weMyExamViews/examLogin/index")  
        },
        {
            path: "/myExam/doExam",
            name: "doExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中',index:2
            },
            component: () => import("@/weMyExamViews/doExam/index")  
        },
        {
            path: "/myExam/mobildDoExam",
            name: "mobildDoExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中',index:2
            },
            component: () => import("@/weMyExamViews/mobileExam/mobildDoExam")  
        },
        {
            path: "/myExam/transcriptExam",
            name: "transcriptExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'成绩单'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'成绩单',index:2
            },
            component: () => import("@/weMyExamViews/transcriptExam/index")  
        },
        {
            path: "/myExam/practiceExam",
            name: "practiceExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'练习考试'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'练习',index:2
            },
            component: () => import("@/weMyExamViews/practiceExam/index")  
        },
        {
            path: "/myExam/mobilePracticeExam",
            name: "mobilePracticeExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'练习考试'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'练习',index:2
            },
            component: () => import("@/weMyExamViews/mobileExam/mobilePracticeExam")  
        }
    ]
}